import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
// import * as serviceworker from './serviceWorker';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// serviceworker.registerServiceWorker();

// function loadPage(sheets: sheetData[]): void {
//   const sheetsView: sheetData[] = sheets;

//   ReactDOM.render(
//     <React.StrictMode>
//       <App sheets={sheetsView} />
//     </React.StrictMode>,
//     document.getElementById('root'),
//   );
// }

// (async function getApp() {
//   const qDoc = await qdtComponents.qDocPromise;

//   const sheets: sheetData[] = [];
//   const sheetsList: string[] = [
//     'gvHRL',
//     'JpgG',
//     'bQCJVe',
//     'KXaxwj'
//   ];

//   function linkSerialized(
//     layout: EngineAPI.IGenericObjectLayout,
//     sheet: string,
//   ): void {
//     let title = '';
//     let idx = 0;
//     let menuIcon: IconType = IoIosPodium;
//     switch (sheet) {
//       case 'gvHRL':
//         title = 'Scorecards';
//         menuIcon = BsClipboardData;
//         idx = 1;
//         break;
//       case 'JpgG':
//         title = 'Selections';
//         menuIcon = BiSelectMultiple;
//         idx = 2;
//         break;
//       case 'bQCJVe':
//         title = 'Geography';
//         menuIcon = RiRoadMapLine;
//         idx = 3;
//         break;
//       case 'KXaxwj':
//         title = 'What if?';
//         menuIcon = BiQuestionMark;
//         idx = 4;
//         break;
//       default:
//         break;
//     }

//     sheets.push({
//       id: String(sheet),
//       title: title || layout.qMeta.title,
//       cells: layout.cells,
//       columns: layout.columns,
//       rows: layout.rows,
//       menuIcon,
//       menuIndex: idx,
//     });
//   }

//   if (qDoc) {
//     Promise.all(
//       sheetsList.map(async sheet => {
//         const obj = await qDoc.getObject(sheet);
//         const layout = await obj.getLayout();
//         linkSerialized(layout, sheet);
//       }),
//     ).then(() => {
//       sheets.push({
//         id: 'leadboard',
//         title: 'Leaderboard',
//         cells: [],
//         columns: 0,
//         rows: 0,
//         menuIcon: IoIosPodium,
//         menuIndex: 0,
//       });

//       sheets.sort((a, b) =>
//         a.menuIndex > b.menuIndex ? 1 : b.menuIndex > a.menuIndex ? -1 : 0,
//       );
//       loadPage(sheets);
//     });
//   }
// })();
